import * as React from 'react';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
// import Button from '@mui/material/Button';
import { Link } from 'wouter';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';
import { PopoverOrigin } from '@mui/material/Popover';
import { signOut, Auth as FirebaseAuth } from 'firebase/auth';
import { User } from './User';

interface DashboardProps {
    auth: FirebaseAuth;
    user?: User;
}

interface DashboardState {
    anchorEl?: HTMLElement;
}

const AnchorOrigin: PopoverOrigin = {
    vertical: 'bottom',
    horizontal: 'right',
};

const Dashboard = styled(
    class DashboardInner extends React.Component<DashboardProps & { className?: string }, DashboardState> {
        constructor(props: DashboardProps) {
            super(props);
            this.state = {
                anchorEl: undefined,
            };
        }

        handleClose = async () => {
            this.setState({ anchorEl: undefined });
            try {
                await signOut(this.props.auth);
            } catch (error) {
                console.error('Logout failed', error);
            }
        };

        handleMenu = (event: React.MouseEvent<HTMLElement>) => {
            this.setState({
                anchorEl: event.currentTarget,
            });
        };

        render() {
            const { className } = this.props;
            const { anchorEl } = this.state;
            const open = Boolean(anchorEl);
            const user = this.props.user;

            const account = user?.photoUrl ? (
                <Avatar alt={user.displayName} src={user.photoUrl} className="simlin-home-avatar" />
            ) : (
                <AccountCircle />
            );

            return (
                <div className={clsx(className, 'simlin-home-root')}>
                    <AppBar position="fixed">
                        <Toolbar variant="dense">
                            <IconButton className="simlin-home-menubutton" color="inherit">
                                <MenuIcon />
                            </IconButton>
                            <Typography variant="h6" color="inherit" className="simlin-home-flex">
                                <Link to="/" className="simlin-home-modellink" style={{ marginRight: '45px' }}>
                                    INDATA
                                </Link>
                                <Link to="/dashboard" className="simlin-home-modellink">
                                    <span style={{ fontWeight: 600 }}>Панель мониторинга</span>
                                </Link>
                            </Typography>
                            <div>
                                <IconButton
                                    className="simlin-home-profileicon"
                                    onClick={this.handleMenu}
                                    color="inherit"
                                >
                                    {account}
                                </IconButton>
                                <Menu
                                    id="menu-appbar"
                                    anchorEl={anchorEl}
                                    anchorOrigin={AnchorOrigin}
                                    transformOrigin={AnchorOrigin}
                                    open={open}
                                >
                                    <MenuItem onClick={() => void this.handleClose()}>
                                        Выйти
                                    </MenuItem>
                                </Menu>
                            </div>
                        </Toolbar>
                    </AppBar>
                    <div style={{ marginTop: '100px', textAlign: 'center' }}>
                        <iframe
                            title="Dashboard"
                            width="95%"
                            height="600"
                            style={{ border: 'none' }}
                            src="https://app.powerbi.com/view?r=eyJrIjoiMDJkMjI3NWQtYjI2Mi00NmU5LWIzM2MtZTljZTQyYTE1NGQ3IiwidCI6ImIwMzg3MGRhLTcxOGQtNDYzZi05NzhjLTcxMDc2YjUwZTM2NiIsImMiOjl9"
                            allowFullScreen
                        />
                    </div>
                </div>
            );
        }
    },
)(() => ({
    '&.simlin-home-root': {
        flexGrow: 1,
    },
    '.simlin-home-flex': {
        flex: 1,
    },
    '.simlin-home-profileicon': {
        padding: 8,
    },
    '.simlin-home-avatar': {
        width: 32,
        height: 32,
    },
    '.simlin-home-menubutton': {
        marginLeft: -12,
        marginRight: 20,
    },
    '.simlin-home-modellink': {
        color: 'white',
        textDecoration: 'none',
    },
}));

export default Dashboard;
